// Pinia Store
import { defineStore, acceptHMRUpdate } from "pinia";
import { NewsService } from "@/services/newsService";
import { useRoute } from "vue-router";

export const useNewsStore = defineStore({
  id: "news",
  state: () => ({
    status: "initial",
    news: [],
    selection: "",
    start: 0,
    limit: 5,
  }),

  getters: {
    newsStatus: (state) => state.status,

    article: (state) => {
      const route = useRoute() || { params: { slug: "" } };

      if (!state.news.length) {
        return {};
      }

      if (state.selection || route.params.slug) {
        const article = state.news.find(
          (article) =>
            article.id === state.selection || article.slug === route.params.slug
        );
        return article || {};
      }

      return state.news[0];
    },
  },

  actions: {
    load() {
      if (this.status === "initial" || this.status === undefined) {
        this.fetchNews();
      }
    },

    async fetchNews(params = {}) {
      try {
        const defaultParams = { limit: this.limit, start: this.start };
        const queryParams = { ...defaultParams, ...params };

        this.status = "loading";
        const newsData = await NewsService.getNews(queryParams);

        this.news = [...newsData];
        this.status = "loaded";
      } catch (error) {
        console.error("Error fetching news:", error);
        this.status = "error";
      }
    },

    select(id) {
      this.selection = id;
    },

    raiseLimit() {
      this.start = 0;
      this.limit = this.limit + 20;
    },

    clear() {
      this.$reset();
    },
  },

  persist: false,
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNewsStore, import.meta.hot));
}
